export const META_COLS = [
    { key: 'stake', label: 'Заказчик / Стейкхолдеры', w: 150, just: 'flex-start' },
    { key: 'effect', label: 'Бизнес-эффект', w: 150, just: 'flex-start' },
    { key: 'effectComment', label: 'Комм. к эффекту', w: 160, just: 'flex-start' },
    { key: 'effort', label: 'Труд., нед', w: 66, just: 'center' },
    { key: 'duration', label: 'Длит., нед', w: 66, just: 'center' },
    { key: 'deps', label: 'Зависимости', w: 130, just: 'flex-start' },
    { key: 'ab', label: 'A/B', w: 56, just: 'center' },
    { key: 'comment', label: 'Комментарий', w: 320, just: 'flex-start' },
];
/** Gantt lane vertical pitch (px) — see segsFor top offset. */
export const GANTT_LANE_PITCH = 20;
/** Wrap meta columns: multiline + max-height cap + overflow popup on click. */
export const WRAP_META_COL_KEYS = ['stake', 'effect', 'effectComment', 'comment', 'deps'];
/** Max wrap-cell height = 5 gantt lanes (raw prototype). */
export const WRAP_CELL_MAX_H = GANTT_LANE_PITCH * 5;
const RU_MONTHS_FULL = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
];
const RU_MONTHS_ABBR = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
/** Backend/API limit (RFC-0013). */
export const MAX_BOARD_WEEKS = 56;
const PROJECT_BIRTH_DATE = new Date(2026, 6, 2);
export function projectAgeDays() {
    const now = new Date();
    const days = Math.max(0, Math.floor((new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() - PROJECT_BIRTH_DATE.getTime()) /
        86400000));
    const n = days % 100;
    const n1 = days % 10;
    let word = 'дней';
    if (n < 11 || n > 14) {
        if (n1 === 1)
            word = 'день';
        else if (n1 >= 2 && n1 <= 4)
            word = 'дня';
    }
    return { days, word };
}
function mondayOfWeekContaining(d) {
    const copy = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    copy.setDate(copy.getDate() - ((copy.getDay() + 6) % 7));
    return copy;
}
function quarterStartDate(year, quarter) {
    return new Date(year, (quarter - 1) * 3, 1);
}
function quarterEndDate(year, quarter) {
    return new Date(year, quarter * 3, 0);
}
function prevQuarter(year, quarter) {
    if (quarter === 1)
        return { year: year - 1, quarter: 4 };
    return { year, quarter: quarter - 1 };
}
function addQuarters(year, quarter, n) {
    let q = quarter + n;
    let y = year;
    while (q > 4) {
        q -= 4;
        y += 1;
    }
    while (q < 1) {
        q += 4;
        y -= 1;
    }
    return { year: y, quarter: q };
}
export function computeBoardWindow(year, quarter) {
    const prev = prevQuarter(year, quarter);
    const prevStart = quarterStartDate(prev.year, prev.quarter);
    const endQ = addQuarters(year, quarter, 2);
    const endDate = quarterEndDate(endQ.year, endQ.quarter);
    const weekStartDate = mondayOfWeekContaining(prevStart);
    const endMonday = mondayOfWeekContaining(endDate);
    const msPerWeek = 7 * 24 * 60 * 60 * 1000;
    const weeksCount = Math.min(MAX_BOARD_WEEKS, Math.floor((endMonday.getTime() - weekStartDate.getTime()) / msPerWeek) + 1);
    return { weekStart: isoDate(weekStartDate), weeksCount };
}
export function buildTimeline(weekStartIso, weeksCount) {
    const parts = weekStartIso.split('-').map(Number);
    const weekDates = [];
    const weeks = [];
    for (let i = 0; i < weeksCount; i++) {
        const d = new Date(parts[0], parts[1] - 1, parts[2]);
        d.setDate(d.getDate() + i * 7);
        weekDates.push(d);
        weeks.push({ d: d.getDate(), ab: RU_MONTHS_ABBR[d.getMonth()] });
    }
    const months = [];
    let currentMonth = -1;
    for (const wd of weekDates) {
        const m = wd.getMonth();
        if (m !== currentMonth) {
            months.push({ name: RU_MONTHS_FULL[m], span: 1 });
            currentMonth = m;
        }
        else {
            months[months.length - 1].span += 1;
        }
    }
    return { weeks, months, weekDates };
}
const _fallbackWindow = computeBoardWindow(2026, 3);
const _fallbackTimeline = buildTimeline(_fallbackWindow.weekStart, _fallbackWindow.weeksCount);
/** @deprecated Use per-tab timeline from buildTimeline */
export const MONTHS = _fallbackTimeline.months;
/** @deprecated Use per-tab timeline from buildTimeline */
export const WEEKS = _fallbackTimeline.weeks;
/** @deprecated Use per-tab timeline from buildTimeline */
export const WEEK_DATES = _fallbackTimeline.weekDates;
export function isoDate(d) {
    if (!d)
        return '';
    const p = (n) => (n < 10 ? '0' : '') + n;
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
export function dateToWeekIndex(iso, weekDates) {
    const parts = iso.split('-').map(Number);
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
    let idx = -1;
    weekDates.forEach((wd, i) => {
        if (wd.getTime() === d.getTime())
            idx = i;
    });
    if (idx < 0)
        idx = d < weekDates[0] ? 0 : weekDates.length - 1;
    return idx;
}
export function currentWeekIndex(weekDates) {
    const monday = mondayOfWeekContaining(new Date());
    let idx = -1;
    weekDates.forEach((wd, i) => {
        if (wd.getTime() === monday.getTime())
            idx = i;
    });
    return idx;
}
export const DEFAULT_STAGES = {
    estimate: { label: 'Верхнеуровневая оценка', color: '#9CA3AF' },
    design: { label: 'Design', color: '#7C8CFF' },
    research: { label: 'Research', color: '#A855F7' },
    analytics: { label: 'Analytics', color: '#4FA3D9' },
    dev: { label: 'Dev', color: '#EB7125' },
    qa: { label: 'QA', color: '#E5C42D' },
    businessTest: { label: 'Business test', color: '#14B8A6' },
    release: { label: 'Release', color: '#22C55E' },
    run: { label: 'RUN', color: '#94A3B8' },
};
export const CHIP_DEFS = [
    { key: 'P0', label: 'P0' },
    { key: 'P1', label: 'P1' },
    { key: 'ab', label: 'Нужен A/B' },
    { key: 'RUN', label: 'RUN' },
    { key: 'OKR-C', label: 'OKR-C' },
    { key: 'OKR-A', label: 'OKR-A' },
];
export const ZOOM_OPTS = [
    ['compact', 'Компактно'],
    ['normal', 'Обычно'],
    ['comfortable', 'Просторно'],
];
export const TYPE_OPTS = [
    { v: 'RUN', label: 'RUN', swatch: '#94A3B8' },
    { v: 'OKR-C', label: 'OKR-C', swatch: '#2563EB' },
    { v: 'OKR-A', label: 'OKR-A', swatch: '#7C3AED' },
    { v: '—', label: '—', swatch: '#E2E8F0' },
];
export const PR_OPTS = [
    { v: 'P0', label: 'P0', swatch: '#2563EB' },
    { v: 'P1', label: 'P1', swatch: '#4FA3D9' },
    { v: 'P2', label: 'P2', swatch: '#94A3B8' },
    { v: 'P3', label: 'P3', swatch: '#CBD5E1' },
    { v: '—', label: '—', swatch: '#E2E8F0' },
];
const PLATFORM_RE = /(Android|Андроид|iOS|IOS|АМИО|АИО|АИ|АМ)/g;
export function titleParts(title) {
    const arr = String(title).split(PLATFORM_RE);
    return arr
        .filter((s) => s !== '')
        .map((s) => ({
        text: s,
        color: /^(Android|Андроид|iOS|IOS|АМИО|АИО|АИ|АМ)$/.test(s) ? '#DC2626' : '#0F172A',
    }));
}
export function weekLabel(i, weeks) {
    const w = weeks[i];
    return w ? `${w.d} ${w.ab}` : '';
}
export function textOn(hex) {
    const m = /^#?([0-9a-fA-F]{6})/.exec(String(hex || ''));
    if (!m)
        return '#FFFFFF';
    const n = parseInt(m[1], 16);
    const r = (n >> 16) & 255;
    const g = (n >> 8) & 255;
    const b = n & 255;
    return 0.299 * r + 0.587 * g + 0.114 * b > 175 ? '#1F2937' : '#FFFFFF';
}
export function segsFor(p, weekW, stages, opts = {}) {
    const { selSeg, isEditor = false, painting, weeks = WEEKS } = opts;
    const list = (p.segs || []).map((s, i) => ({ s, i }));
    const sorted = list.slice().sort((a, b) => a.s.start - b.s.start || a.i - b.i);
    const lanes = {};
    let lane = 0;
    let prevEnd = -1;
    let maxLane = 0;
    sorted.forEach((it, k) => {
        lane = k > 0 && it.s.start < prevEnd ? lane + 1 : lane;
        lanes[it.i] = lane;
        prevEnd = it.s.start + it.s.len;
        if (lane > maxLane)
            maxLane = lane;
    });
    const out = sorted.map((it) => {
        const s = it.s;
        const cfg = stages[s.stage] || { label: s.stage, color: '#94A3B8' };
        const label = s.label || (s.stage === 'run' ? p.runLabel || 'RUN' : cfg.label);
        const w = s.len * weekW - 2;
        const selected = !!(selSeg && selSeg.id === p.id && selSeg.idx === it.i);
        return {
            i: it.i,
            left: s.start * weekW + 1,
            w,
            h: 22,
            top: 5 + lanes[it.i] * 20,
            color: cfg.color,
            label,
            textColor: textOn(cfg.color),
            labelDisplay: w >= 46 ? 'inline' : 'none',
            fw: s.stage === 'dev' ? '700' : '600',
            z: selected ? 10 : 2 + lanes[it.i],
            ring: selected
                ? '0 0 0 2px #FFFFFF, 0 0 0 4px #2563EB, 0 6px 16px rgba(15,23,42,.28)'
                : 'inset 0 -1px 0 rgba(15,23,42,.12)',
            selected: selected && isEditor,
            op: '1',
            pe: 'auto',
            tip: `${label} · ${weekLabel(s.start, weeks)} – ${weekLabel(s.start + s.len - 1, weeks)} (${s.len} нед)`,
        };
    });
    if (painting && painting.id === p.id) {
        const a = Math.min(painting.from, painting.to);
        const b = Math.max(painting.from, painting.to);
        const cfg = stages[painting.stageSel] || { label: '', color: '#94A3B8' };
        out.push({
            i: -1,
            left: a * weekW + 1,
            w: (b - a + 1) * weekW - 2,
            h: 22,
            top: 5,
            color: cfg.color,
            label: cfg.label,
            textColor: textOn(cfg.color),
            labelDisplay: 'none',
            fw: '600',
            z: 12,
            ring: '0 0 0 2px rgba(37,99,235,.4)',
            selected: false,
            op: '0.65',
            pe: 'none',
            tip: '',
        });
    }
    return { segs: out, maxLane };
}
export function typeStyle(t) {
    if (!t || t === '—')
        return { bg: 'transparent', color: '#94A3B8', bd: '#E2E8F0' };
    if (t === 'RUN')
        return { bg: '#F1F5F9', color: '#475569', bd: '#E2E8F0' };
    if (t === 'OKR-C')
        return { bg: '#FFFFFF', color: '#1D4ED8', bd: '#93C5FD' };
    if (t === 'OKR-A')
        return { bg: '#F5F3FF', color: '#6D28D9', bd: '#C4B5FD' };
    return { bg: 'transparent', color: '#94A3B8', bd: 'transparent' };
}
export function prStyle(p) {
    if (p === 'P0')
        return { bg: '#2563EB', color: '#FFFFFF' };
    if (p === 'P1')
        return { bg: '#4FA3D9', color: '#FFFFFF' };
    if (p === 'P2')
        return { bg: '#94A3B8', color: '#FFFFFF' };
    if (p === 'P3')
        return { bg: '#CBD5E1', color: '#334155' };
    return { bg: 'transparent', color: '#94A3B8' };
}
export function zoomCfg(key) {
    return ({
        compact: { w: 34, h: 32 },
        normal: { w: 42, h: 38 },
        comfortable: { w: 52, h: 44 },
    }[key] || { w: 34, h: 32 });
}
export function gridBg(weekW) {
    return `repeating-linear-gradient(to right, transparent 0px, transparent ${weekW - 1}px, #EDF1F7 ${weekW - 1}px, #EDF1F7 ${weekW}px)`;
}
export function passesFilter(p, search, chipSet) {
    const s = search.trim().toLowerCase();
    if (s && !p.title.toLowerCase().includes(s))
        return false;
    const pris = ['P0', 'P1'].filter((k) => chipSet[k]);
    if (pris.length && !pris.includes(p.priority))
        return false;
    const types = ['RUN', 'OKR-C', 'OKR-A'].filter((k) => chipSet[k]);
    if (types.length && !types.includes(p.type))
        return false;
    if (chipSet.ab && p.ab !== 'Да')
        return false;
    return true;
}
